import React, { useEffect, useState } from "react";
import { RiArrowLeftSLine } from "react-icons/ri";
import Footer from "../components/Footer";
import LoggedNav from "../components/LoggedNav";
import PopUp from "../components/Popup";
import Spinner from "./BePatient";
import Rating from '@mui/material/Rating';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import { isMobile } from "react-device-detect";
import OwlCarousel from 'react-owl-carousel';
import { useNavigate } from "react-router-dom";
import profile from "../images/Vector.jpg";
import LinkPayment from './LinkPayment';
import DeletePaymentMethod from './DeletePaymentMethod';

function BrowseChef(props) {
  const [details, setDetails] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isPaymentLinked, setIsPaymentLinked] = useState(false); 

  function extractValue(arr, prop) {
    return arr.map(item => item[prop]);
  }

  let navigate = useNavigate();

  const updateChefs = async () => {
    setLoading(true);
    let data = await fetch(
      `${process.env.REACT_APP_BASE_URL}user/loggedin_chef_detail`,
      {
        method: "POST",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          user_id: localStorage.getItem("logged_user_id") || "",
          email: localStorage.getItem("owner") || ""
        }),
      }
    );
    let parsedData = await data.json();
    parsedData.data[0].chef_rating = 4.5; 
    parsedData.data[0].chef_total_number_of_reviews = 10; 
    setDetails(parsedData.data);
    setLoading(false);
  };   

  // ✅ check payment status API
  const checkPaymentStatus = async () => {
    try {
      const user_id = localStorage.getItem("logged_user_id");
      const token = localStorage.getItem("token");

      // STEP 1: Call user/get_chef_account_details
      const getAccountDetailsResponse = await fetch(
        `${process.env.REACT_APP_BASE_URL}user/get_chef_account_details`,
        {
          method: "POST",
          headers: {
            Authorization: "Bearer " + token,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ user_id }),
        }
      );
      const getAccountDetailsData = await getAccountDetailsResponse.json();
      console.log("get_chef_account_details Response:", getAccountDetailsData);
      const normalizedEmailStatus = String(getAccountDetailsData.emailStatus || "")
        .replace(/[\s_]/g, "")
        .toUpperCase();

      // STEP 2: Conditionally call syncChefPayPalStatus
      if (
        getAccountDetailsData.status === true &&
        normalizedEmailStatus === "NOTCONFIRMED"
      ) {
        // Keep Link disabled and Delete enabled when account exists.
        setIsPaymentLinked(true);

        const syncPayPalStatusResponse = await fetch(
          `${process.env.REACT_APP_BASE_URL}user/syncChefPayPalStatus`,
          {
            method: "POST",
            headers: {
              Authorization: "Bearer " + token,
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ userId: user_id }),
          }
        );
        const syncPayPalStatusData = await syncPayPalStatusResponse.json();
        console.log("syncChefPayPalStatus Response:", syncPayPalStatusData);

        // STEP 3: Determine PayPal readiness
        if (
          syncPayPalStatusData.success &&
          syncPayPalStatusData.primary_email_confirmed === true &&
          syncPayPalStatusData.payments_receivable === true
        ) {
          setIsPaymentLinked(true);
        } else {
          setIsPaymentLinked(true);
        }
      } else if (
        getAccountDetailsData.status === true &&
        normalizedEmailStatus === "CONFIRMED"
      ) {
        // Do not call sync for confirmed status.
        setIsPaymentLinked(true);
      } else {
        setIsPaymentLinked(false); // If not syncing, assume not linked or already confirmed
      }
    } catch (err) {
      console.error("Error in checkPaymentStatus:", err);
      setIsPaymentLinked(false);
    }
  };

  let role = localStorage.getItem("role");
  let token = localStorage.getItem("token");

  useEffect(() => {
    const title = "Profile | CHEF | CHEF REPUBLIC";
    const desc = "View Chef Profile in Detail including the menu, available timings, learn about the Chef, get to know the chef by viewing their pics";

    document.title = title;
    document.querySelector("meta[name='title']").setAttribute('content', title);
    document.querySelector("meta[name='description']").setAttribute('content', desc);
    document.querySelector("meta[property='og:title']").setAttribute('content', title);
    document.querySelector("meta[property='og:description']").setAttribute('content', desc);
    document.querySelector("meta[property='twitter:title']").setAttribute('content', title);
    document.querySelector("meta[property='twitter:description']").setAttribute('content', desc);

    if (role === null || role !== "2") {
      navigate("/chef/sign-in");
      window.location.reload();
    }
    if (token === null || !token) {
      navigate("/chef/sign-in");
      window.location.reload();
    }

    updateChefs();
    checkPaymentStatus();

    // EXTRA REQUIREMENT: Re-check PayPal status every 15 seconds
    const intervalId = setInterval(() => {
      checkPaymentStatus();
    }, 15000);

    // Clear interval on component unmount
    return () => clearInterval(intervalId);

  }, [role, token, navigate]);

  function navigateEdit() {
    navigate("/chef/profile/edit");
  }

  function logout() {
    localStorage.clear();
    navigate("/chef");
  }

  // Add this handler
  const handlePaymentDeleted = () => {
    checkPaymentStatus(); // Refresh payment status
    updateChefs(); // Refresh chef details
  };

  return (
    <>
      {loading ? (
        <Spinner />
      ) : (
        <>
          <LoggedNav customer={props.customer} />
          <div className="container mt-5 ">
            {!isMobile && (
              <nav aria-label="breadcrumb">
                <a href="/chef/order-list" style={{ textDecoration: "none", color: "black", fontWeight: 500 }}>
                  <RiArrowLeftSLine size={"2rem"} />
                  <span style={{ color: "#1e1e1e", fontWeight: 400 }}>Order List</span>
                </a>
              </nav>
            )}

            <div className="main_container row mt-4" style={{ display: "flex", flexDirection: isMobile ? "column" : "row" }}>
              {/* Sidebar */}
              <div className="col-4 vstack prof pe-4">
                <OwlCarousel items={1} center mouseDrag touchDrag autoplay autoplayHoverPause dotsEach className="owl-theme mb-4 shadow rounded-4 p-2" loop>
                  <div className="d-flex justify-content-center align-items-center">
                    <img alt="" className="image_box img-fluid" src={details[0].chef_profile_image} style={{ maxHeight: "15rem", width: "auto", maxWidth: "90%" }} />
                  </div>
                  {details[0].chef_images.map((element, index) => (
                    <div className="d-flex justify-content-center align-items-center" key={index}>
                      <img alt="" className="image_box img-fluid" src={element} style={{ maxHeight: "15rem", width: "auto", maxWidth: "90%" }} />
                    </div>
                  ))}
                </OwlCarousel>

                <button onClick={navigateEdit} type="button" className="btn btn-orange rounded-pill mb-3">Edit Profile</button>
                
                {/* ✅ Buttons with condition */}
                <LinkPayment isPaymentLinked={isPaymentLinked} />
                
                <DeletePaymentMethod 
                  isPaymentLinked={isPaymentLinked} 
                  onPaymentDeleted={handlePaymentDeleted}  // Add this prop
                />

                <button onClick={() => { navigate("/chef/order-list"); }} type="button" className="btn btn-orange rounded-pill mb-3">Order List</button>
                <button onClick={logout} type="button" className="btn btn-orange rounded-pill mb-3">Logout</button>
              </div>

              {/* Main Content */}
              <div className="col-8 py-3">
                <div className="box_title">
                  <h4 className="fw-bold">{details[0].chef_name + (details[0].chef_sex ? ", " + details[0].chef_sex : "")}</h4>
                  <h6 className="mt-3">{details[0].chef_city}</h6>
                </div>

                <div className="d-flex justify-content-start pt-3 mt-3">
                  <Rating name="half-rating-read" defaultValue={Number(details[0].chef_rating)} precision={0.5} readOnly />
                  <div className="d-flex justify-content-center ms-3">
                    <p style={{ fontSize: "0.9rem", color: "#7C7C7C" }}>
                      {details[0].chef_total_number_of_reviews} reviews
                    </p>
                  </div>
                </div> 

                <hr />

                <div className="message_box my-2 py-2">
                  <h5 className="my-2" style={{ fontWeight: 700 }}>I can cook</h5>
                  <h6 className="mt-2">{details[0].chef_categories ? extractValue(details[0].chef_categories, "category_name").join(", ") : ""}</h6>
                </div>

                <button type="button" className="btn-orange" data-bs-toggle="modal" data-bs-target="#staticBackdrop">View my menu</button>
                <PopUp chef_name={details[0].chef_name} rich_text_menu={details[0].rich_text_menu} pdf={details[0].chef_menu} />

                <hr />

                <div className="message_box my-2 py-2">
                  <h5 className="my-2 pb-2" style={{ fontWeight: 700 }}>My Availability</h5>
                  <div className="row d-flex justify-content-between">
                    {["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"].map(day =>
                      details[0].chef_availability && details[0].chef_availability[day].length > 0 ? (
                        <div className="col-6 row my-1" key={day}>
                          <p style={{ fontSize: "0.9rem", fontWeight: 700 }} className="col-3">{day.slice(0, 3).charAt(0).toUpperCase() + day.slice(1, 3)}:</p>
                          <p style={{ fontSize: "0.9rem" }} className="col-9 p-0">{details[0].chef_availability[day].join("; ")}</p>
                        </div>
                      ) : null
                    )}
                  </div>
                </div>

                <hr />

                <div className="message_box my-4 ">
                  <h5 className="my-2 py-2" style={{ fontWeight: 700 }}>About me</h5>
                  <p className="my-2">{details[0].chef_description}</p>
                </div>

                <hr />

                <div className="message_box my-4">
                  <h5 className="my-2" style={{ fontWeight: 700 }}>Client Reviews</h5>

                  {details[0].chef_reviews && details[0].chef_reviews.length > 0 ? (
                    <OwlCarousel items={1} mouseDrag touchDrag autoplay autoplayHoverPause dotsEach className="owl-theme my-4" loop>
                      {details[0].chef_reviews.map((element, index) => (
                        <div className="item" key={index}>
                          <Rating name="half-rating-read" defaultValue={Number(element.rating)} precision={0.5} readOnly />
                          <p className="mt-2 text-wrap text-break" style={{ fontSize: "0.9rem" }}>{element.review_content}</p>
                          <div className="d-flex justify-content-start align-items-center">
                            <div className="ratings text-warning h4 my-3">
                              <img src={element.user_image ? element.user_image : profile} className="rounded-pill" style={{ width: "35px", height: "35px" }} alt="" />
                            </div>
                            <p className="review-count" style={{ marginLeft: "15px", marginBottom: "1px", fontSize: "0.9rem" }}>{element.reviewed_by}</p>
                          </div>
                        </div>
                      ))}
                    </OwlCarousel>
                  ) : (
                    <p className="my-2 text-justify">No Review Yet</p>
                  )}
                </div>
              </div>
            </div>
          </div>
          <Footer top={1} />
        </>
      )}
    </>
  );
}

export default BrowseChef;


